import { useAppSelector } from 'shared/lib';

import { getScenario } from 'entities/scenario';

import type { ScenarioWithContentHeader } from '../types';

import { checkScenarioHasContentHeader } from './checkScenarioHasContentHeader';

export const useCurrentScenarioWithContentHeader = (): ScenarioWithContentHeader | null => {
  const scenario = useAppSelector(getScenario);

  if (checkScenarioHasContentHeader(scenario)) {
    return scenario;
  }

  return null;
};
